var EmailFormTextInputView, EmailFormTextParagraphInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormTextParagraphInputView = (function(superClass) {
  extend(EmailFormTextParagraphInputView, superClass);

  function EmailFormTextParagraphInputView() {
    return EmailFormTextParagraphInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextParagraphInputView.prototype.tagName = 'li';

  EmailFormTextParagraphInputView.prototype.events = {
    'keyup .text_paragraph_input': 'validateEmailForm'
  };

  EmailFormTextParagraphInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".text_paragraph_input";
    return this.template = {
      text_paragraph_input_template: true
    };
  };

  return EmailFormTextParagraphInputView;

})(EmailFormTextInputView);

module.exports = EmailFormTextParagraphInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vdGV4dF9wYXJhZ3JhcGhfaW5wdXRfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL2NvbW1vbi90ZXh0X3BhcmFncmFwaF9pbnB1dF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHVEQUFBO0VBQUE7OztBQUFBLHNCQUFBLEdBQXlCLE9BQUEsQ0FBUSxvQ0FBUjs7QUFFbkI7Ozs7Ozs7NENBQ0osT0FBQSxHQUFTOzs0Q0FFVCxNQUFBLEdBQ0U7SUFBQSw2QkFBQSxFQUErQixtQkFBL0I7Ozs0Q0FFRixVQUFBLEdBQVksU0FBQTtJQUNWLHNCQUFzQixDQUFBLFNBQUUsQ0FBQSxVQUFVLENBQUMsS0FBbkMsQ0FBeUMsSUFBekMsRUFBK0MsU0FBL0M7SUFDQSxJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtNQUFDLDZCQUFBLEVBQStCLElBQWhDOztFQUhGOzs7O0dBTmdDOztBQVc5QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
